<template>
  <div class="gf-field">
    <input type="file" ref="uploadField" :placeholder="placeholder" @change="selectFile" :multiple="multiple" :webkitdirectory="folder" :mozdirectory="folder" />
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder", "multiple", "folder"],
  mixins: [componentMixin],
  methods: {
    selectFile() {
      this.$emit("update:modelValue", [...this.$refs.uploadField.files]);
    },
  },
}
</script>
